import { render } from "./EditMedication.vue?vue&type=template&id=68072593&scoped=true"
import script from "./EditMedication.vue?vue&type=script&lang=js"
export * from "./EditMedication.vue?vue&type=script&lang=js"

import "./EditMedication.vue?vue&type=style&index=0&id=68072593&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68072593"]])

export default __exports__